import { defineComponent } from 'vue';
export default defineComponent({
    props: {
        item: {
            type: Object,
            default: function () { return ({}); }
        }
    }
});
